import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { FC } from 'react';

import { customConfig } from '_features/custom/custom.config';
import * as S from '_features/stories/components/header/header.styles';

export const HeroHeader: FC = () => {
  const { t } = useTranslation(customConfig.i18nNamespaces);

  return (
    <S.Header className="bg-secondary-900 sm:pt-32 pt-16 relative" data-testid="stories-hero-header">
      <div className="container-lg">
        <h1 className="serif bold mb-4 sm:mb-6 text-neutral-100">{t('stories:hero.title')}</h1>
        <p className="h6 text-secondary-300">{t('stories:hero.subtitle')}</p>
      </div>
    </S.Header>
  );
};
